module.exports = __webpack_public_path__ + "static/paris-017-8b78c595d306f97e6e75e6e20b74b3c3.jpg";